import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#69005b',
  width = '100%',
  className = '',
  viewBox = '0 0 107.047 85.638',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      id="city-solid_1_"
      className="icon"
      data-name="city-solid (1)"
      d="M103.033,32.114H80.285V4.014A4.013,4.013,0,0,0,76.271,0H52.185a4.013,4.013,0,0,0-4.014,4.014V16.057h-10.7V2.676A2.675,2.675,0,0,0,34.79,0H32.114a2.675,2.675,0,0,0-2.676,2.676V16.057h-10.7V2.676A2.675,2.675,0,0,0,16.057,0H13.381A2.675,2.675,0,0,0,10.7,2.676V16.057H4.014A4.013,4.013,0,0,0,0,20.071V80.285a5.353,5.353,0,0,0,5.352,5.352h96.342a5.353,5.353,0,0,0,5.352-5.352V36.128A4.014,4.014,0,0,0,103.033,32.114ZM21.409,67.573A2.007,2.007,0,0,1,19.4,69.58h-6.69A2.007,2.007,0,0,1,10.7,67.573v-6.69a2.007,2.007,0,0,1,2.007-2.007H19.4a2.007,2.007,0,0,1,2.007,2.007Zm0-16.057A2.007,2.007,0,0,1,19.4,53.523h-6.69A2.007,2.007,0,0,1,10.7,51.516v-6.69a2.007,2.007,0,0,1,2.007-2.007H19.4a2.007,2.007,0,0,1,2.007,2.007Zm0-16.057A2.007,2.007,0,0,1,19.4,37.466h-6.69A2.007,2.007,0,0,1,10.7,35.459v-6.69a2.007,2.007,0,0,1,2.007-2.007H19.4a2.007,2.007,0,0,1,2.007,2.007ZM42.819,67.573a2.007,2.007,0,0,1-2.007,2.007h-6.69a2.007,2.007,0,0,1-2.007-2.007v-6.69a2.007,2.007,0,0,1,2.007-2.007h6.69a2.007,2.007,0,0,1,2.007,2.007Zm0-16.057a2.007,2.007,0,0,1-2.007,2.007h-6.69a2.007,2.007,0,0,1-2.007-2.007v-6.69a2.007,2.007,0,0,1,2.007-2.007h6.69a2.007,2.007,0,0,1,2.007,2.007Zm0-16.057a2.007,2.007,0,0,1-2.007,2.007h-6.69a2.007,2.007,0,0,1-2.007-2.007v-6.69a2.007,2.007,0,0,1,2.007-2.007h6.69a2.007,2.007,0,0,1,2.007,2.007ZM69.58,51.516a2.007,2.007,0,0,1-2.007,2.007h-6.69a2.007,2.007,0,0,1-2.007-2.007v-6.69a2.007,2.007,0,0,1,2.007-2.007h6.69a2.007,2.007,0,0,1,2.007,2.007Zm0-16.057a2.007,2.007,0,0,1-2.007,2.007h-6.69a2.007,2.007,0,0,1-2.007-2.007v-6.69a2.007,2.007,0,0,1,2.007-2.007h6.69a2.007,2.007,0,0,1,2.007,2.007Zm0-16.057a2.007,2.007,0,0,1-2.007,2.007h-6.69A2.007,2.007,0,0,1,58.876,19.4v-6.69A2.007,2.007,0,0,1,60.883,10.7h6.69a2.007,2.007,0,0,1,2.007,2.007ZM96.342,67.573a2.007,2.007,0,0,1-2.007,2.007h-6.69a2.007,2.007,0,0,1-2.007-2.007v-6.69a2.007,2.007,0,0,1,2.007-2.007h6.69a2.007,2.007,0,0,1,2.007,2.007Zm0-16.057a2.007,2.007,0,0,1-2.007,2.007h-6.69a2.007,2.007,0,0,1-2.007-2.007v-6.69a2.007,2.007,0,0,1,2.007-2.007h6.69a2.007,2.007,0,0,1,2.007,2.007Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
